import module from 'facturacion/configuracion/module.js'
import template from './template.html'

export class FacturacionConfiguracionConceptosEditarImpuestosAgregarComponent {
  idConcepto
  data
  onClose
  procesando = false
  catalogo = {
    impuestos: [],
    factores: [],
    tasasfactores: [],
    tipoImpuesto: [
      {id: 1, descripcion: 'Traslado'},
      {id: 2, descripcion: 'Retención'},
    ],
  }

  constructor ($q, FacturacionConfiguracionConceptosConceptoImpuestos, FacturacionConfiguracionImpuestos, FacturacionConfiguracionFactores, FacturacionConfiguracionTasaFactor) {
    this.$q = $q
    this.FacturacionConfiguracionImpuestos = FacturacionConfiguracionImpuestos
    this.FacturacionConfiguracionFactores = FacturacionConfiguracionFactores
    this.FacturacionConfiguracionTasaFactor = FacturacionConfiguracionTasaFactor
    this.FacturacionConfiguracionConceptosConceptoImpuestos = FacturacionConfiguracionConceptosConceptoImpuestos
  }

  $onInit () {
    this.$promise = this.$q.all([
      this.FacturacionConfiguracionImpuestos.get().then(({data}) => (this.catalogo.impuestos = data)),
      this.FacturacionConfiguracionFactores.get().then(({data}) => (this.catalogo.factores = data)),
      this.FacturacionConfiguracionTasaFactor.get().then(({data}) => (this.catalogo.tasasfactores = data)),
    ])
  }

  aceptar () {
    if (this.procesando) return
    this.procesando = true

    const factor = this.catalogo.factores.find((item) => item.factor === this.data.factor)
    this.data.factor_id = factor.id

    this.FacturacionConfiguracionConceptosConceptoImpuestos.post(this.idConcepto, this.data)
      .then(({data}) => (this.onClose({$event: {details: data}})))
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    this.onClose({$event: {details: null}})
  }
}

module.component('facturacionConfiguracionConceptosEditarImpuestosAgregar', {
  controller: FacturacionConfiguracionConceptosEditarImpuestosAgregarComponent,
  template,
  bindings: {
    idConcepto: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/components/conceptos/editar/impuestos/agregar/component.js